import useGet from "../useGet";

const useDenominations = (
  currencyId: any,
  showDisabled = false,
  dependencies: any[] = []
) => {
  const { value, loading } = useGet(
    `/api/Currencies/${currencyId}/denominations?show-disabled=${showDisabled}&ts=` +
      new Date().getTime(),
    "Unable to read the denominations",
    [],
    [currencyId, ...dependencies],
    undefined,
    () => typeof currencyId !== "undefined" && currencyId !== null
  );

  return { denominations: value, denominationsLoading: loading };
};

export default useDenominations;
